import axios from "./axiosConfig";

export function submitAssignment(formData) {
    return axios
        .post("/api/v1/user/assignment/save", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
}

export function getAssignment(courseId, moduleId, sectionId) {
    return axios
        .get(`/api/v1/user/assignment/get/${courseId}/${moduleId}/${sectionId}`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
}

export function resubmitAssignment(assignmentId, formData) {
    return axios
        .put(`/api/v1/user/assignment/resubmit/${assignmentId}`, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
}
